export const ACCOUNT_STORE = "ACCOUNT_STORE";
export const ACCOUNT_CLEAR = "ACCOUNT_CLEAR";
export const ACCOUNT_IMPERSONATING_CONTACT_ID_STORE = "ACCOUNT_IMPERSONATING_CONTACT_ID_STORE";
export const ACCOUNT_REGISTERING_AS_STORE = "ACCOUNT_REGISTERING_AS_STORE";
export const ACCOUNT_GET_AUTH_TOKEN = "ACCOUNT_GET_AUTH_TOKEN";
export const ACCOUNT_AUTH_TOKEN_STORE = "ACCOUNT_AUTH_TOKEN_STORE";
export const REGISTRATION_MEMBERSHIP_TYPE_STORE = "REGISTRATION_MEMBERSHIP_TYPE_STORE";
export const MEMBERSHIP_JOIN_RENEW_TYPE_STORE = "MEMBERSHIP_JOIN_RENEW_TYPE_STORE";
export const REGISTRATION_METHOD_STORE = "REGISTRATION_METHOD_STORE";
export const REGISTRATION_METHOD_CLEAR = "REGISTRATION_METHOD_CLEAR";
